import { GiftCodeStatus } from '@src/models/giftCodeStatus';

export const giftCodeStatusLabel: Record<GiftCodeStatus, string> = {
  [GiftCodeStatus.UNPROVIDED]: '미지급',
  [GiftCodeStatus.PROVISION]: '지급 완료',
  [GiftCodeStatus.USED]: '사용 완료'
};
